import * as React  from "react";
import { useState, useRef } from 'react'
import Modal from "./modal";
import ModalInterviewAnswer from "./modalInterviewAnswer";
import ModalInterviewLink from "./modalInterviewLink";
import ModalInterviewCancel from "./modalInterviewCancel";
import ModalInterviewSetupUrl from "./modalInterviewSetupUrl";
import axios from 'axios';

const Index = (props) => {
  const [selectedInterview, setSelectedInterview] = useState({ categories: [], interview_contents: [], interview_answers: [], patientName: []});
  const [selectedInterviewLink, setSelectedInterviewLink] = useState({id: 0, interview_key: "", patient_name: "", display_flg: 0, line_linked: false, patientId: 0});
  const [selectedPatient, setSelectedPatient] = useState({id: 0, kanzyano: "", linked_patient_name: "", linked_patient_birthday: "", mobile_phone_number: "", address: "", d_interview_detail_id: 0});
  const [indexProps, setIndexProps] = useState(props.d_interview_details);
  const [defaultIndexProps, setDefaultIndexProps] = useState(props.all_d_interview_details);
  const [selectedDay, setSelectedDay] = useState(new Date());
  const [isAlreadyHanded, setIsAlreadyHanded] = useState(true);
  const [isfilledOut, setIsFilledOut] = useState(true);
  const [isFillingIn, setIsFillingIn] = useState(true);
  const [isWaitingForLink, setIsWaitingForLink] = useState(true);
  const [isAlreadyLinked, setIsAlreadyLinked] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const [selectedUnlinkedPatient, setSelectedUnlinkedPatient] = useState({ dInterviewDetailId: 0, patientBirthday: "" });
  const [update, setUpdate]= useState<boolean>(false);
  const inputEl = useRef(null);

  function handleToDate(date) {
    date = new Date(date);
    date = date.getFullYear()+"/"+(date.getMonth()%12+1)+"/"+date.getDate();
    return date;
  }

  function handleToTime(date) {
    date = new Date(date);
    if (date.getMinutes() < 10) {
      var time = date.getHours()+":0"+date.getMinutes();
    } else {
      var time = date.getHours()+":"+date.getMinutes();
    }
    return time;
  }

  function changeDateFormat(date) {
    var y = date.getFullYear();
    var m = ('00' + (date.getMonth()+1)).slice(-2);
    var d = ('00' + date.getDate()).slice(-2);
    return (y + '-' + m + '-' + d);
  }

  function calcAge(birthdayStr){
    if(isNaN(birthdayStr)||birthdayStr.length !== 8){
      return -1;
    }
    var d = new Date();
    var dStr = ''+d.getFullYear()+('0'+(d.getMonth()+1)).slice(-2)+('0'+d.getDate()).slice(-2);
    return Math.floor((parseInt(dStr)-parseInt(birthdayStr))/10000);
  }

  function convertToRyakuWareki(date) {
    if (date == null) {
      return "";
    }
    var seirekiDate = new Date(date);
    var ryakuWareki = seirekiDate.toLocaleDateString("ja-JP-u-ca-japanese", {era:"narrow", year:"2-digit"}).replace("年", "");
    if (ryakuWareki.includes('元')) {
      ryakuWareki = ryakuWareki.replace("元", "1");
    }
    var month = ('00' + (seirekiDate.getMonth()+1)).slice(-2);
    var dt = ('00' + seirekiDate.getDate()).slice(-2);
    var ryakuWarekiDate = ryakuWareki + month + dt;
    return ryakuWarekiDate;

  }

  // function colorChange(e) {
  //   if (e.target.style.backgroundColor == "rgb(255, 153, 153)") {
  //     e.target.style.backgroundColor = "rgb(255, 255, 153)";
  //     e.target.innerHTML = "対応中";
  //   } else if (e.target.style.backgroundColor == "rgb(255, 255, 153)") {
  //     e.target.style.backgroundColor = "rgb(221, 221, 221)";
  //     e.target.innerHTML = "対応完了";
  //   } else if (e.target.style.backgroundColor = "rgb(221, 221, 221)") {
  //     e.target.style.backgroundColor = "rgb(255, 153, 153)";
  //     e.target.innerHTML = "〇";
  //   }
  // }

  function initializeFilter() {
    if (isAlreadyHanded === false) {
      setIsAlreadyHanded(true);
    }

    if (isfilledOut === false) {
      setIsFilledOut(true);
    }

    if (isFillingIn === false) {
      setIsFillingIn(true);
    }

    if (isWaitingForLink === false) {
      setIsWaitingForLink(true);
    }

    if (isAlreadyLinked === false) {
      setIsAlreadyLinked(true);
    }

    // 非表示はデフォルトでは含めない様にしたいので、日付変更などがあった場合はfalseにする
    if (isHidden === true) {
      setIsHidden(false);
    }
  }

  // 開始時間とステータスでソートする関数
  function sortDInterviewDetails(dInterviewDetails) {
    // 送信済み(「送信済み」のみ開始日時がないので、送信日時でソート)
    const unsortedStatus0 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 0});
    const status0 = unsortedStatus0.sort(function(a, b) { return (a.created_at < b.created_at ? 1 : -1) });
    // 入力済み
    const unsortedStatus1 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 1});
    const status1 = unsortedStatus1.sort(function(a, b) { return (a.start_at < b.start_at ? 1 : -1) });
    // 入力中
    const unsortedStatus2 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 2});
    const status2 = unsortedStatus2.sort(function(a, b) { return (a.start_at < b.start_at ? 1 : -1) });
    // 連携待ち
    const unsortedStatus3 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 3});
    const status3 = unsortedStatus3.sort(function(a, b) { return (a.start_at < b.start_at ? 1 : -1) });
    // 連携済み
    const unsortedStatus4 = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.status === 4});
    const status4 = unsortedStatus4.sort(function(a, b) { return (a.start_at < b.start_at ? 1 : -1) });

    // 「送信済み→入力中→入力済み→連携待ち→連携済み」の順になる様に配列を結合
    const newDInterviewDetails = status0.concat(status2, status1, status3, status4);
    return newDInterviewDetails;
  }

  function getSelectedStatusDInterviewDetails(status, defaultIndexProps) {
    if (isHidden === true) {
      const filteredDInterviewDetails = defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status);
      return filteredDInterviewDetails;
    } else {
      const filteredDInterviewDetails = defaultIndexProps.filter(dInterviewDetail => dInterviewDetail.status === status && dInterviewDetail.display_flg === 1);
      return filteredDInterviewDetails;
    }
  }

  function getFilteredDInterviewDetails(defaultIndexProps) {
    let newDInterviewDetails = [];
    // 各ステータスのフィルターがtrueの場合取得する 
    if (isAlreadyHanded === true) {
      newDInterviewDetails = newDInterviewDetails.concat(getSelectedStatusDInterviewDetails(0, defaultIndexProps));
    }
 
    if (isfilledOut === true) {
      newDInterviewDetails = newDInterviewDetails.concat(getSelectedStatusDInterviewDetails(1, defaultIndexProps));
    }
 
    if (isFillingIn === true) {
      newDInterviewDetails = newDInterviewDetails.concat(getSelectedStatusDInterviewDetails(2, defaultIndexProps));
    }
 
    if (isWaitingForLink === true) {
      newDInterviewDetails = newDInterviewDetails.concat(getSelectedStatusDInterviewDetails(3, defaultIndexProps));
    } 
    
    if (isAlreadyLinked === true) {
      newDInterviewDetails = newDInterviewDetails.concat(getSelectedStatusDInterviewDetails(4, defaultIndexProps));
    }
    return newDInterviewDetails;
  }

  function changeFlag(flag, status) {
    switch (status) {
      case 0:
        setIsAlreadyHanded(flag ? false : true);
        break;
      case 1:
        setIsFilledOut(flag ? false : true);
        break;
      case 2:
        setIsFillingIn(flag ? false : true);
        break;
      case 3:
        setIsWaitingForLink(flag ? false : true);
        break;
      case 4:
        setIsAlreadyLinked(flag ? false : true);
        break;
    }
  }

  function filterIndexProps(flag, status) {
    if (flag === true) {
      const newIndexProps = indexProps.filter(dInterviewDetail => !(dInterviewDetail.status === status));
      changeFlag(flag, status);
      setIndexProps(newIndexProps);
    } else {
      if (isHidden == true) {
        const filteredDInterviewDetails = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.status === status);
        const newIndexProps = indexProps.concat(filteredDInterviewDetails);
        const sortedIndexProps = sortDInterviewDetails(newIndexProps);
        setIndexProps(sortedIndexProps);
      } else {
        const filteredDInterviewDetails = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.status === status && dInterviewDetail.display_flg === 1);
        const newIndexProps = indexProps.concat(filteredDInterviewDetails);
        const sortedIndexProps = sortDInterviewDetails(newIndexProps);
        setIndexProps(sortedIndexProps);
      }
      changeFlag(flag, status);
    }
  }

  function getDInterviewDetails(date, type) {
    if (type == "select") {
      const today = new Date();
      const freelySelectedDay = new Date(String(date));
      if (freelySelectedDay > today) {
        date = new Date();
      }  
    }
    axios.get(
      '/api/internal/interview/get_d_interview_details', {
        params: {
          date: date,
          type: type
        }
      })
      .then(function (response) {
        const new_d_interview_details = response.data.d_interview_details;
        const all_new_d_interview_details = response.data.all_d_interview_details;
        const newDate = new Date(`${response.data.date}`);
        inputEl.current.value = changeDateFormat(newDate);
        setSelectedDay(newDate);
        initializeFilter();
        setIndexProps(new_d_interview_details);
        setDefaultIndexProps(all_new_d_interview_details);
      })
      .catch(error => {
        console.log(error.response)
      });
  }

  // 名前クリック時にヒアリング回答を表示
  function onClickName(interview_detail_id) {
    setSelectedInterview({categories: [], interview_contents: [], interview_answers: [], patientName: []});
    axios.get(
      '/api/internal/interview/get_interview', {
        params: {
          interview_detail_id: interview_detail_id,
        }
      })
      .then(function (response) {
        setSelectedInterview(response.data);
      })
      .catch(error => {
        alert(error.response.data.message);
      }); 
  }

 function viewInfoChangeAlert(dInterviewDetails) {
  const updatedNameDids = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.nupdatef === 1 && dInterviewDetail.is_new_patient === false});
  const updatedBirthdayDids = dInterviewDetails.filter(dInterviewDetail => {return dInterviewDetail.bupdatef === 1 && dInterviewDetail.is_new_patient === false});
   if (updatedNameDids.length > 0 || updatedBirthdayDids.length > 0) {
     return true
   } else {
     return false
   }
 }

  // 紐づけや紐づけ解除後(紐づけ後の処理など後でまとめる)
  function updateIndexProps(updatedDefaultIndexProps) {
    // フィルターに合わせてdefaultIndexPropsからd_interview_detailを取得
    const updatedIndexProps = getFilteredDInterviewDetails(updatedDefaultIndexProps);
    // 参照用と表示用のステートを時間とステータスでソート
    const newDefaultIndexProps = sortDInterviewDetails(updatedDefaultIndexProps);
    const newIndexProps = sortDInterviewDetails(updatedIndexProps);
    // 新しくなったdefaultIndexPropsとindexPropsを更新
    setDefaultIndexProps(newDefaultIndexProps);
    setIndexProps(newIndexProps);
    // 再レンダリングを実行
    setUpdate(update ? false: true);
  }

  //  非表示の追加・削除
  function filterHiddenDInterviewDetails(flg) {
    if (flg === true) {
      const newIndexProps = indexProps.filter(dInterviewDetail => !(dInterviewDetail.display_flg === 0));
      setIndexProps(newIndexProps);
      setIsHidden(false);
    } else {
      let filteredDInterviewDetails = []
      if (isAlreadyHanded === true) {
        const hiddenStatus0 = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.display_flg === 0 && dInterviewDetail.status === 0);
        filteredDInterviewDetails = filteredDInterviewDetails.concat(hiddenStatus0);
      }
      if (isfilledOut === true) {
        const hiddenStatus1 = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.display_flg === 0 && dInterviewDetail.status === 1);
        filteredDInterviewDetails = filteredDInterviewDetails.concat(hiddenStatus1);
      }
      if (isFillingIn === true) {
        const hiddenStatus2 = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.display_flg === 0 && dInterviewDetail.status === 2);
        filteredDInterviewDetails = filteredDInterviewDetails.concat(hiddenStatus2);
      }
      if (isWaitingForLink === true) {
        const hiddenStatus3 = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.display_flg === 0 && dInterviewDetail.status === 3);
        filteredDInterviewDetails = filteredDInterviewDetails.concat(hiddenStatus3);
      }
      if (isAlreadyLinked === true) {
        const hiddenStatus4 = defaultIndexProps.filter((dInterviewDetail) => dInterviewDetail.display_flg === 0 && dInterviewDetail.status === 4);
        filteredDInterviewDetails = filteredDInterviewDetails.concat(hiddenStatus4);
      }
      const newIndexProps = indexProps.concat(filteredDInterviewDetails);
      const sortedIndexProps = sortDInterviewDetails(newIndexProps);
      setIndexProps(sortedIndexProps);
      setIsHidden(true);
    }
  }

  // 先確認リンクモーダルを表示
  async function showSelectedInterviewLink(d_interview_detail){
    const element = document.getElementById("show_select_interview_button");
    setSelectedInterviewLink({id: d_interview_detail.id, interview_key: d_interview_detail.interview_key, patient_name: d_interview_detail.name, display_flg: d_interview_detail.display_flg, line_linked: false, patientId: d_interview_detail.m_patient_id})
    // 再来の患者のみLINE連携済みかチェックを行う
    !d_interview_detail.is_new_patient && (
      await axios.get(
        '/api/internal/patients/check_line_linked', {
          params: {
            m_patient_id: d_interview_detail.m_patient_id
          }
        })
        .then(function (response) {
          setSelectedInterviewLink({id: d_interview_detail.id, interview_key: d_interview_detail.interview_key, patient_name: d_interview_detail.name, display_flg: d_interview_detail.display_flg, line_linked: response.data.line_linked, patientId: d_interview_detail.m_patient_id})
        })
        .catch(error => {
          alert(error.response.data.message);
        })
    );
    // モーダルが先に開いてしまうため、別のタグでモーダルを指定してここでクリック処理
    element.click();
  }

  return (
    <>
      <div className="interview-status-header">
        <h2>先確認受付一覧</h2>
        <div>
          <button className="btn btn-lg btn-primary btn-block interview-status-button" onClick={ ()=> location.href="/interview/setup"}>患者受付</button>
          {
            props.m_institution.is_interview_unification && (
              <button className="btn btn-lg btn-primary btn-block interview-status-button" data-toggle="modal" data-target="#modalInterviewSetupUrl">共通QRコード</button>
            )
          }
          
        </div>
      </div>
      <br/>
      <div className="filter-wrapper">
        <label>ステータス</label>
        <div>
          <label className="status-filter-label pointer"><input className="pointer" type="checkbox" checked={isAlreadyHanded} onChange={() => filterIndexProps(isAlreadyHanded, 0)}/>送信済み</label>
          <label className="status-filter-label pointer"><input className="pointer" type="checkbox" checked={isFillingIn} onChange={() => filterIndexProps(isFillingIn, 2)} />入力中</label>
          <label className="status-filter-label pointer"><input className="pointer" type="checkbox" checked={isfilledOut} onChange={() => filterIndexProps(isfilledOut, 1)} />入力済み</label>
          <label className="status-filter-label pointer"><input className="pointer" type="checkbox" checked={isWaitingForLink} onChange={() => filterIndexProps(isWaitingForLink, 3)} />連携待ち</label>
          <label className="status-filter-label pointer"><input className="pointer" type="checkbox" checked={isAlreadyLinked} onChange={() => filterIndexProps(isAlreadyLinked, 4)} />連携済み</label>
        </div>
        <div>
          <label className="pointer"><input className="pointer" type="checkbox" checked={isHidden} onChange={() => filterHiddenDInterviewDetails(isHidden)} />非表示を含める</label>
        </div>
      </div>

      <div className="date-select-wrapper">
        <div className="date-select-content">
          <div className="date-change-button-wrapper">
            {/* 今日の分を表示しているなら「今日」ボタンは表示しない */}
            {changeDateFormat(selectedDay) != changeDateFormat(new Date())
              ?  <button type="button" className="btn btn-outline-info" onClick={() => getDInterviewDetails(new Date(), "today")}>今日</button>
              :  <></>
            }   
          </div>
          <div className="date-change-button-wrapper2">
            <div className="date-change-button-wrapper">
              <button type="button" className="btn btn-outline-info" onClick={() => getDInterviewDetails(selectedDay, "previous")}>&lt;</button>
            </div>
            <div className="date-select-area">
              {/* {showDate(selectedDay)} */}
              <input
                type="date"
                defaultValue={changeDateFormat(selectedDay)}
                max={changeDateFormat(new Date())}
                ref={inputEl}
                onChange={(e) => getDInterviewDetails(e.target.value, "select")}
                className="date-select-field" />
            </div>
            <div className="date-change-button-wrapper">
                  <button 
                    type="button"
                    className="btn btn-outline-info"
                    onClick={() => getDInterviewDetails(selectedDay, "next")}
                    disabled={changeDateFormat(selectedDay) != changeDateFormat(new Date())
                      ? false
                      : true
                    }
                    >&gt;</button>
            </div>
          </div>
          <div className="date-change-button-wrapper">
          </div>
        </div>
      </div>


      <div className="table-responsive message-table-content">
        <table id="notice_table" className="table table-bordered">
          <thead>
            <tr className="success">
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">患者番号</th>
              <th scope="col" className="text-center col-md-2 col-lg-2 va_middle">患者名</th>
              <th scope="col" className="text-center col-md-2 col-lg-2 va_middle">生年月日</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">新／再</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle monshin-type">質問タイプ</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle monshin-status">ステータス</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">送信日時</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">入力開始<br/>日時</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">残薬調整</th>
              <th scope="col" className="text-center col-md-1 col-lg-1 va_middle">相談</th>
              {/* <th scope="col" className="text-center col-lg-1">受け取り</th> */}
            </tr>
          </thead>
          <tbody>
            {indexProps.map((d_interview_detail, i) => (
                <tr key={i} data-dinterviewdetailid={d_interview_detail.id} id={`d-interview-detail${d_interview_detail.id}`}
                            className={d_interview_detail.display_flg === 0 ? "hidden-d-interview-detail" : ""}>
                  {/* 患者番号 */}
                  {d_interview_detail.m_patient_id == null && d_interview_detail.status == 1 ? 
                    <td className="text-center va_middle">
                      <button
                      type="button"
                      className="btn btn-warning linkmodal-fadein-button"
                      onClick={() => setSelectedUnlinkedPatient({dInterviewDetailId: d_interview_detail.id,
                                                                 patientBirthday: convertToRyakuWareki(d_interview_detail.birthday)})}
                      data-toggle="modal"
                      data-target="#messageModal">
                        <span className="glyphicon glyphicon-plus-sign message-modal-icon"></span>紐づけ
                      </button>
                    </td>
                   : 
                    <td className="text-center va_middle">
                      {/* ステータスが「連携待ち」か「連携済み」の時のみ紐づけモーダルを表示させる */}
                      {d_interview_detail.status === 3 || d_interview_detail.status === 4 ? 
                        <a type="text"
                           className="cursol-pointer"
                           data-toggle="modal"
                           data-target="#modalInterviewCancel"
                           onClick={() => setSelectedPatient({id: d_interview_detail.m_patient_id,
                                                              kanzyano: d_interview_detail.kanzyano,
                                                              linked_patient_name: d_interview_detail.patient_name,
                                                              linked_patient_birthday: d_interview_detail.patient_birthday,
                                                              mobile_phone_number: d_interview_detail.mobile_phone_number,
                                                              address: d_interview_detail.address,
                                                              d_interview_detail_id: d_interview_detail.id})}>
                        <u>{d_interview_detail.kanzyano}</u>
                       </a>
                      :
                        `${d_interview_detail.kanzyano}`
                      }
                    </td>  
                  }

                  {/* 患者氏名 */}
                  <td className="text-center va_middle">
                    {
                      // 問診データがまだ登録されていない時は患者氏名をクリックした時に問診画面へ遷移できるリンクが記載されているモーダルを表示する
                      !d_interview_detail.d_sheet_id ? (
                        <>
                          <a id="show_select_interview_link" type="text" className="cursol-pointer" onClick={(e) => showSelectedInterviewLink(d_interview_detail)}>
                            <u className="did-name">{d_interview_detail.name}</u>
                          </a>
                          <input type="hidden" id="show_select_interview_button" data-toggle="modal" data-target="#modalInterviewLink"/>
                        </>
                      ):(
                        // 問診データが登録されている場合は患者氏名をクリックした時に問診データが記載されているモーダルを表示する
                        <a type="text" className="cursol-pointer" onClick={() => onClickName(d_interview_detail.id)} data-toggle="modal" data-target="#modalInterviewAnswer">
                          <u className="did-name">{d_interview_detail.name}
                            {d_interview_detail.is_new_patient === false && d_interview_detail.nupdatef === 1 ?
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle notice-warning-icon" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                              </svg>
                              :
                              <></>
                            }
                          </u>
                        </a>
                      ) 
                    }
                  </td>

                  {/* 生年月日 */}
                  {/* calcAge(patient.birthday.replace(/-/g , '')) */}
                  {d_interview_detail.birthday != null
                    ? <td className="text-center va_middle">
                        <div className="birthday-td-inline">
                          { d_interview_detail.japanese_calendar_birthday + '（' + calcAge(d_interview_detail.birthday.replace(/-/g , '')) + '）' }
                          {d_interview_detail.is_new_patient === false && d_interview_detail.bupdatef === 1 ?
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-triangle notice-warning-icon" viewBox="0 0 16 16">
                              <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                              <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                            </svg>
                            :
                            <></>
                          }
                        </div>
                      </td>
                    : <td className="text-center va_middle"></td> 
                  }

                  {/* 新患or再来表示 */}
                  {d_interview_detail.is_new_patient
                    ? <td className="text-center va_middle">新患</td>
                    : <td className="text-center va_middle">再来</td>
                  }

                  {/* 質問タイプ */}
                  <td className="text-center va_middle">
                   {d_interview_detail.template_name}
                  </td>

                  {/* ステータス表示 */}
                  {(() => {
                    switch (d_interview_detail.status) {
                      case 0:
                        return <td className="text-center va_middle already-handed" id={`d-interview-detail${d_interview_detail.id}-status`}>送信済み</td>;
                      case 1:
                        return <td className="text-center va_middle filled-out" id={`d-interview-detail${d_interview_detail.id}-status`}>入力済み</td>;
                      case 2:
                        return <td className="text-center va_middle filling-in" id={`d-interview-detail${d_interview_detail.id}-status`}>入力中</td>;
                      case 3:
                        return <td className="text-center va_middle waiting-for-link" id={`d-interview-detail${d_interview_detail.id}-status`}>連携待ち</td>;
                      case 4:
                        return <td className="text-center va_middle already-linked" id={`d-interview-detail${d_interview_detail.id}-status`}>連携済み</td>;
                    }
                  })()}

                  {/* 送信日時 */}
                  <td className="text-center va_middle">
                    {handleToDate(d_interview_detail.created_at)}<tr/>
                    {handleToTime(d_interview_detail.created_at)}
                  </td>

                  {/* 入力開始日時 */}
                  {d_interview_detail.start_at == null
                    ? <td className="text-center va_middle"></td>
                    :  <td className="text-center va_middle">
                         {handleToDate(d_interview_detail.start_at)}<tr/>
                         {handleToTime(d_interview_detail.start_at)}
                       </td>
                  }

                  {/* 残薬調整 */}
                  {d_interview_detail.is_leftover_medicine
                    ? <td className="text-center va_middle">〇</td>
                    : <td className="text-center va_middle"></td>
                  }

                  {/* 相談 */}
                  {d_interview_detail.is_question
                    ? <td className="text-center va_middle">〇</td>
                    : <td className="text-center va_middle"></td>
                  }
                  
                  {/* {(() => {
                      if (d_interview_detail.receipt_location === 0) {
                          return <td className="text-center va_middle">薬局窓口</td>;
                      } else if (d_interview_detail.receipt_location === 1) {
                          return <td className="text-center va_middle">薬局ロッカー</td>;
                      } else {
                          return <td className="text-center va_middle">配送</td>;
                      }
                  })()} */}
                </tr>
            ))}
          </tbody>
        </table>
      </div>

      {viewInfoChangeAlert(indexProps) ? (
        <div className="info-change-alert-text">※患者氏名や生年月日にアイコンが出ている場合は、患者マスタとヒアリングの登録内容が異なります</div>
        ) : (
          <></>
        )
      }

      <Modal dInterviewDetailId={selectedUnlinkedPatient.dInterviewDetailId}
             patientBirthday={selectedUnlinkedPatient.patientBirthday}
             defaultIndexProps={defaultIndexProps}
             updateIndexProps={updateIndexProps} />
      <ModalInterviewAnswer interviewCategories={selectedInterview.categories} interviewQuestions={selectedInterview.interview_contents} interviewAnswers={selectedInterview.interview_answers} patientName={selectedInterview.patientName}/>
      <ModalInterviewLink id={selectedInterviewLink.id}
                          interviewKey={selectedInterviewLink.interview_key}
                          patientName={selectedInterviewLink.patient_name}
                          display_flg={selectedInterviewLink.display_flg}
                          defaultIndexProps={defaultIndexProps}
                          updateIndexProps={updateIndexProps} 
                          line_linked={selectedInterviewLink.line_linked}
                          patientId={selectedInterviewLink.patientId}  />
      <ModalInterviewCancel id={selectedPatient.id}
                            kanzyano={selectedPatient.kanzyano}
                            name={selectedPatient.linked_patient_name}
                            birthday={selectedPatient.linked_patient_birthday}
                            mobile_phone_number={selectedPatient.mobile_phone_number}
                            address={selectedPatient.address}
                            d_interview_detail_id={selectedPatient.d_interview_detail_id}
                            defaultIndexProps={defaultIndexProps}
                            updateIndexProps={updateIndexProps} />
      <ModalInterviewSetupUrl institution_key={props.m_institution.institution_key} />
      
    </>
  )
}

export default Index
